import Component from "./components"

declare global {
    interface Window {
        Components: Component
    }
}

globalThis.window.Components = new Component()